<template>
    <!-- 订单管理 -->
    <div>
        <div class="conditionSearchBox">
            <div class="conditionItem">
                <el-date-picker v-model="date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
                </el-date-picker>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.orderno" placeholder="订单编号" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.classname" placeholder="班级名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.studentname" placeholder="学员姓名" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <div class="mb-15">
            <el-button type="primary" icon="el-icon-plus" @click="openAddOrderDialog">新增订单</el-button>
            <el-button type="primary" plain icon="el-icon-download" @click="exportOrder">导出订单</el-button>
        </div>
        <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" ref="table">
            <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                <template slot-scope="scope">
                    <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                </template>
            </el-table-column>
            <el-table-column prop="orderno" label="订单编号" align="center" width="200" key="orderno" fixed show-overflow-tooltip>
                <template slot-scope="scope">
                    <p class="pointer color-brand" @click="openOrderDetails(scope.row)">{{scope.row.orderno}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="nickname" label="学员昵称" align="center" width="100" :formatter="formatTab" key="nickname" fixed show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="studentname" label="学员姓名" align="center" width="100" key="studentname" show-overflow-tooltip></el-table-column>
            <el-table-column prop="campusname" label="所在校区" align="center" width="200" key="campusname" :formatter="formatTab" show-overflow-tooltip></el-table-column>
            <el-table-column prop="telno" label="联系方式" align="center" width="150" key="telno" :formatter="formatTab" show-overflow-tooltip></el-table-column>
            <el-table-column prop="classname" label="班级名称" align="center" min-width="200" key="classname" :formatter="formatTab" show-overflow-tooltip></el-table-column>
            <el-table-column prop="uprice" label="订单金额" align="center" width="120" key="uprice" :formatter="formatTab" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p style="text-align:right">{{(scope.row.uprice)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="nowprice" label="支付金额" align="center" width="120" key="nowprice" :formatter="formatTab" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p style="text-align:right">{{scope.row.nowprice}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="ordersourcename" label="购买来源" align="center" width="100" key="ordersourcename" :formatter="formatTab" show-overflow-tooltip></el-table-column>
            <el-table-column prop="paytypename" label="支付方式" align="center" width="100" key="paytypename" :formatter="formatTab" show-overflow-tooltip></el-table-column>
            <el-table-column prop="statusname" label="订单状态" align="center" width="100" key="statusname" :formatter="formatTab" show-overflow-tooltip></el-table-column>
            <el-table-column prop="datetime" label="下单时间" align="center" width="150" key="datetime" :formatter="formatTab" show-overflow-tooltip></el-table-column>
            <el-table-column prop="paytime" label="支付时间" align="center" width="150" key="paytime" :formatter="formatTab" show-overflow-tooltip></el-table-column>
            <el-table-column prop="" label="操作" fixed="right" align="right" width="150" key="edit">
                <template slot-scope="scope">
                    <div class="color-brand flex jc-sa ai-c">
                        <p class="pointer" v-if="scope.row.status === 9" @click="confirmOrderPayResult(scope.row)">确认支付</p>
                        <p v-else class="color-text-sec">确认支付</p>
                        <p class="pointer" v-if="scope.row.status === 9" @click="closeOrder(scope.row)">关闭</p>
                        <p v-else class="color-text-sec">关闭</p>
                        <p class="pointer" v-if="scope.row.status === 10" @click="openReFundOrderDialog(scope.row)">退款</p>
                        <p v-else class="color-text-sec">退款</p>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
        <AddOrderDialog ref="addOrderDialog" @saveSuccess="search"></AddOrderDialog>
        <OrderDetails ref="OrderDetails"></OrderDetails>
        <ReFundOrderDialog ref="ReFundOrderDialog" @saveSuccess="search"></ReFundOrderDialog>
    </div>
</template>
<script>
import {
  getTableDefaultPageSize,
  formatMoney
} from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import {
  getOrderList,
  closeOrder,
  confirmOrderPayResult,
  exportOrder
} from '@/api/measApi/transactionManage.js'
import AddOrderDialog from './components/addOrderDialog.vue'
import OrderDetails from './components/orderDetails.vue'
import ReFundOrderDialog from './components/reFundOrderDialog.vue'
export default {
  data() {
    return {
      params: {
        condition: {
          classcode: '',
          classname: '',
          datetimebegin: '',
          datetimeend: '',
          orderno: '',
          studentcode: '',
          studentname: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      date: [],
      tableData: [],
      contentLoading: false,
      total: 0,
      isSelect: false
    }
  },
  components: {
    TableSort,
    Page,
    AddOrderDialog,
    OrderDetails,
    ReFundOrderDialog
  },
  created() {
    this.getOrderList()
  },
  methods: {
    //   获取订单列表
    getOrderList() {
      this.contentLoading = true
      if (this.date && this.date.length > 0) {
        this.params.condition.datetimebegin = this.date[0]
        this.params.condition.datetimeend = this.date[1]
      } else {
        this.params.condition.datetimeend = ''
        this.params.condition.datetimebegin = ''
      }
      getOrderList(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.total = res.pageinfo.rowcount
          this.contentLoading = false
          this.tableData.map(item => {
            item.uprice = formatMoney(item.uprice)
            item.nowprice = formatMoney(item.nowprice)
          })
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getOrderList()
    },
    // 重置
    reset() {
      this.date = []
      this.params = {
        condition: {
          classcode: '',
          classname: '',
          datetimebegin: '',
          datetimeend: '',
          orderno: '',
          studentcode: '',
          studentname: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getOrderList()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getOrderList()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getOrderList()
    },
    // 初始化表格
    formatTab(row, column, value) {
      return value ? value : '--'
    },
    // 新增订单
    openAddOrderDialog() {
      this.$refs.addOrderDialog.handleOpen()
    },
    // 打开订单详情
    openOrderDetails(row) {
      this.$refs.OrderDetails.handleOpen(row.code)
    },
    // 确认支付结果
    confirmOrderPayResult(row) {
      let status = ''
      this.$confirm('确认支付结果?', '提示', {
        confirmButtonText: '支付成功',
        cancelButtonText: '支付失败',
        type: 'warning',
        customClass: 'measElMessage'
      })
        .then(() => {
          status = 10
        })
        .catch(() => {
          status = 11
        })
        .finally(() => {
          const params = {
            code: row.code,
            orderno: row.orderno,
            status: status
          }
          confirmOrderPayResult(params).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.params.page = 1
              this.getOrderList()
            }
          })
        })
    },
    // 关闭
    closeOrder(row) {
      this.$confirm('关闭订单后前端将不能继续支付，确定吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'measElMessage'
      })
        .then(() => {
          closeOrder({ code: row.code }).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.params.page = 1
              this.getOrderList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消关闭'
          })
        })
    },
    // 退款
    openReFundOrderDialog(row) {
      this.$refs.ReFundOrderDialog.handleOpen(row)
    },
    // 导出
    exportOrder() {
      exportOrder(this.params, '订单.xls')
    }
  }
}
</script>
